export default Object.freeze({
    PENDING: 0, // Pendiente
    APPROVED: 10, // Factura puede venderse
    REJECTED: 20, // No se autoriza la venta
    // Descartado debido a que la factura ya se paso a credito
    // En vez de autorizar una factura, se rehabilitó la dragón de nuevo y los reviews quedan en el aire
    // El cron se dedica a hacer match de estos reviews que se quedarían en el aire
    DISCARD: 30
})
